import isInteger from 'lodash/isInteger';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { I18n } from 'common/i18n';
import {
  setLogarithmicScale,
  setTreatNullValuesAsZero,
  setMeasureAxisPrecision,
} from 'common/authoring_workflow/actions';
import {
  isLogarithmicScale,
  getTreatNullValuesAsZero,
  getMeasureAxisPrecision,
} from 'common/authoring_workflow/selectors/vifAuthoring';
import { AuthoringWorkflowState } from 'common/authoring_workflow/reducers/types';

const scope = 'shared.visualizations.panes.axis.fields.scale';

export const LogarithmicScaleSelector = () => {
  const dispatch = useDispatch();
  const vifAuthoring = useSelector((state: AuthoringWorkflowState) => state.vifAuthoring);
  const checked = isLogarithmicScale(vifAuthoring);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    dispatch(setLogarithmicScale(isChecked));
    // Enabling log scale does not support treat null values as zero or custom measure axis precision.
    // Reset configuration for those values.
    if (getTreatNullValuesAsZero(vifAuthoring)) {
      dispatch(setTreatNullValuesAsZero(false));
    }
    if (isInteger(getMeasureAxisPrecision(vifAuthoring))) {
      dispatch(setMeasureAxisPrecision());
    }
  };

  return (
    <div className="authoring-field checkbox">
      <input checked={checked} id="logarithmic-scale" onChange={handleChange} type="checkbox" />
      <label className="inline-label" htmlFor="logarithmic-scale">
        <span className="fake-checkbox">
          <span className="icon-checkmark3"></span>
        </span>
        {I18n.t('logarithmic_scale', { scope })}
      </label>
    </div>
  );
};
